/**
 * MenuNotFoundPage — shown when a menu slug in the URL doesn't match any
 * active menu for this restaurant.
 */

import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui'

interface MenuNotFoundPageProps {
  slug: string
}

export function MenuNotFoundPage({ slug }: MenuNotFoundPageProps) {
  const { t } = useTranslation()

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-6">
      <div className="text-center space-y-4 max-w-sm">
        <div className="text-5xl">&#127869;</div>
        <h1 className="text-2xl font-bold text-foreground">{t('common:menuNotFound')}</h1>
        <p className="text-muted-foreground text-sm">
          {t('common:noActiveMenuAtSlug', { slug })}
        </p>
        <Button
          onClick={() => {
            window.history.pushState({}, '', '/')
            window.dispatchEvent(new PopStateEvent('popstate'))
          }}
          className="mt-2 min-h-[44px]"
        >
          {t('common:viewAllMenus')}
        </Button>
      </div>
    </div>
  )
}
